import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import wixData from 'wix-data';
import { session } from 'wix-storage';
import { getLoggedInUser, getUserCountry } from 'public/users.js'
import { searchDomain2, suggest } from 'backend/domainSearch';
import { TLD_NOT_SUPPORTED, validateDomain, validateDomainCO, validateDomainMX, SHORT_DOMAIN, LONG_DOMAIN, NOT_VALID, getTldForPurchase, getTldForPurchaseCO, getTldForPurchaseMX, prices } from 'public/validate'
import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('domains', 19, { msid: '1af66153-8fd6-497b-9595-e27baadaaa69' });
// /wix/api/mpContainerStaticController?originWidgetName=domains&domainSearch=true&referralAdditionalInfo=ANY_TEXT
// https://users.wix.com/signin?sendEmail=true&view=login&originUrl=https:%2F%2Fwww.wix.com%2Fdomain%2Fnames&postSignUp=&postLogin=https:%2F%2Fwww.wix.com%2Fmy-account&overrideLocale=es&forceRender=true


let loadMore = 5;
let url = wixLocation.url
let repeaterData = [];
let startTimeView;

let isUserLocalCO
let isUserLocalMX
$w.onReady(function () {
    pageEvents();
});

async function pageEvents() {
// $w('#html')
    // $w('#button1').link = '/wix/api/mpContainerStaticController?originWidgetName=domains&domainSearch=true&referralAdditionalInfo=ANY_TEXT'

    try {
        let geolocation = await wixWindow.getCurrentGeolocation()
        try {

            console.log(geolocation.coords.latitude, geolocation.coords.longitude)
            let results = await getUserCountry(geolocation.coords.latitude, geolocation.coords.longitude)
            //  let results = await getUserCountry('19.4326', '-99.1332') //colombia
            // 23.6345° N, 102.5528° W
            console.log(results, "here")
            if (results.status !== "ZERO_RESULTS") {
                if (results.plus_code.compound_code.includes('Mexico')) {
                    // console.log('in germany')
                    isUserLocalMX = true;
                } else {
                    isUserLocalMX = false;
                }

                if (results.plus_code.compound_code.includes('Colombia')) {
                    // console.log('in germany')
                    isUserLocalCO = true;
                } else {
                    isUserLocalCO = false;
                }
            } else {
                isUserLocalCO = false;
                isUserLocalMX = false;
            }
        } catch (err) {
            console.log("something went wrong getting country")
        }

    } catch (err) {
        console.log("something went wrong getting geo")
    }

    console.log({isUserLocalCO, isUserLocalMX})
    $w('#input1').focus();
    hideResults();
     $w('#disclamer').hide()
    inputDomainEvents();
    resultRepeaterEvents();
    if (wixWindow.formFactor === 'Desktop') { stickyHeaderEvents(); }
}

async function inputDomainEvents() {
    $w('#input1').focus();
    $w('#input1').onKeyPress(async (e) => {
        hideResults()
        $w('#xIcone').show();
        let inputDomain = $w('#input1').value;
        await validateInput(e.key)
        if (e.key === 'Enter') { setTimeout(() => { searchForDomain(); }, 600) }
        if ($w('#input1').value === '') { hideResults() }
    });
    $w('#xIcone').onClick(() => {
        hideResults();
        $w('#input1').value = ''
    });
    $w('#gXIcone').onClick(() => {
        hideResults()
        $w('#input1').value = ''
        $w('#gXIcone').hide()
    });
    $w('#searchDomain').onClick(() => { setTimeout(() => { searchForDomain(); }, 600) });
}

async function resultRepeaterEvents() {
    $w('#suggestionsrepeater').onItemReady(($item, itemData, index) => {
        $item('#domainSuggestion').text = itemData.domain;
        $item('#domainPrice').text = `a partir de $${itemData.price}/año`
        $w('#suggestionsrepeater').expand();
        if (index === 0) {
            $item('#getIt').show();
            $item('#recomended').show();
            $item('#hoverBox').style.backgroundColor = '#F2F4F5';
        }
        $item('#repeaterItem').onMouseIn(async () => {
            $w('#suggestionsrepeater').forEachItem(($Otheritem, OtheritemData, Otherindex) => {
                if (index !== Otherindex) {
                    $Otheritem('#hoverBox').style.backgroundColor = '#FFFFFF'
                    $Otheritem('#getIt').hide();
                }
            })
            $item('#hoverBox').style.backgroundColor = '#F2F4F5'
            $item('#getIt').show();
        });
        $item('#repeaterItem').onMouseOut(async () => {
            $item('#hoverBox').style.backgroundColor = '#FFFFFF'
            $item('#getIt').hide()
        });
        $item('#getDomainBtn').onClick(() => {
            startTimeView = new Date();
            getDomain(`${itemData.price}/año `, itemData.domain, index + 1, 'suggestion')
        })
        $item('#getIt').onClick(() => {
            startTimeView = new Date();
            getDomain(`${itemData.price}/año `, itemData.domain, index + 1, 'suggestion')
        })
        if (index >= loadMore) {
            $w('#loadMore').expand();
            $item('#repeaterItem').collapse()
        }
    });

    $w('#loadMore').onClick(async () => {
        loadMore += 5;
        let data = repeaterData
        $w('#suggestionsrepeater').data = data.slice(0, loadMore)
        let result = data.slice(loadMore - 5, loadMore)
        $w('#suggestionsrepeater').forEachItem(($item, itemData, index) => {
            if (index < loadMore) { $item('#repeaterItem').expand() }
        })
        if (loadMore >= repeaterData.length) { $w('#loadMore').collapse() }

        try {
            const biEventObject = { evid: 953, result: JSON.stringify(result), searchTerm: $w('#input1').value };
            await biLogger.log(biEventObject);
        } catch (err) {
            console.log('load more BI event ERR', err)
        }
    });
}

async function stickyHeaderEvents() {
    $w('#stickyHeaderAnchor').onViewportLeave(() => { $w('#stickyHeader').show() })
    $w('#stickyHeaderAnchor').onViewportEnter(() => { $w('#stickyHeader').hide() })
    $w('#input2').onKeyPress(async (e) => {
        if (e.key === 'Enter') {
            $w('#input1').value = $w('#input2').value;
            $w('#input2').value = '';
            $w('#stickyHeader').hide()
            await validateInput()
            setTimeout(() => { searchForDomain(); }, 600)
            $w('#columnStrip4').scrollTo();
        }
    });

    $w('#input2').onFocus(() => { hideResults() })
    $w('#headerSearch').onClick(async () => {
        $w('#input1').value = $w('#input2').value;
        $w('#input2').value = '';
        $w('#stickyHeader').hide();
        await validateInput()
        setTimeout(() => { searchForDomain(); }, 600)
        $w('#columnStrip4').scrollTo();
    })
}

async function validateInput(e) {
    setTimeout(async () => {
        let inputDomain = $w('#input1').value
        if (inputDomain.startsWith('https://')) {
            $w('#input1').value = inputDomain.replace('https://', '');
            $w('#textError').text = "Introduce el dominio sin 'https://'."
            $w('#textError').expand();
        } else if (inputDomain.startsWith('http://')) {
            $w('#input1').value = inputDomain.replace('http://', '');
            $w('#textError').text = "Introduce el dominio sin 'http://'."
            $w('#textError').expand();
        } else if (e) {
            if ((e.match(/^([-a-zA-Z0-9\.]+)$/) === null)) {
                $w('#input1').value = inputDomain.replace(`${e}`, '');
                $w('#textError').text = 'EIntroduce sólo letras, números, puntos y guiones.'
                $w('#textError').expand();
            } else if (e.match(/^[A-Z ]+$/) !== null) {
                $w('#input1').value = inputDomain.toLocaleLowerCase();
            }
        }
    }, 500)
}
let fire = true
async function searchForDomain() {
    let startTime, endTime, type, seconds;
    startTime = new Date();
    if (fire) {
        try {
            const biEventObjectSearch = { evid: 950, text: $w("#input1").value };
            await biLogger.log(biEventObjectSearch);
        } catch (err) {
            console.log('search domain BI event ERR', err)
        }
    }
    hideResults()
     $w('#disclamer').hide()
    repeaterData = [];

    $w('#preloader').show();
    $w('#repeaterMsg').collapse();
    $w('#suggestionsrepeater').data = [];
    let domainName = $w("#input1").value;
    domainName = domainName.replace('www.', '')

    if (!domainName) {
        $w('#preloader').hide();
        return;
    }
    if (!$w('#textError').collapsed) {
        $w('#preloader').hide();
        return;
    }
    $w('#textError').collapse();

    if (domainName.length < 3 || domainName.startsWith('.')) {
        $w('#preloader').hide();
        $w('#textError').text = 'Ingresa un dominio que incluya al menos 3 caracteres.';
        $w('#input1').focus()
        $w('#textError').expand();
        return;
    }

    if (domainName.split(".").length - 1 > 1 && !domainName.endsWith(".co.uk") && !domainName.endsWith(".com.br")) {
        $w('#preloader').hide();
        $w('#textError').text = 'Los subdominios no están disponibles.';
        $w('#input1').focus()
        $w('#textError').expand();
        return;
    }

    if (domainName.match(/^([-a-zA-Z0-9\.]+)$/) === null) { domainName = await lookForTld(domainName); }
    if (!domainName.includes('.')) {
        $w('#input1').value = domainName + '.com'
        // if (isUserLocalCO) {
        //     $w('#input1').value = domainName + '.co'
        // }
        // if (isUserLocalMX) {
        //     $w('#input1').value = domainName + '.mx'
        // }

        fire = false
        searchForDomain()
        return;
    }

    try {
        let sanitizedDomain = await validateDomain(`${domainName}`)
        // if (isUserLocalCO) {
        //     sanitizedDomain = await validateDomainCO(`${domainName}`)
        // }

        // if (isUserLocalMX) {
        //     sanitizedDomain = await validateDomainMX(`${domainName}`)
        // }

		// if (!isUserLocalMX && !isUserLocalCO) {
        //     sanitizedDomain = await validateDomain(`${domainName}`)
        // }

        

        try {
            let results = await searchDomain2(domainName)
            if (results.available) {
                let domain, price;
                $w('#searchDomain').hide();
                $w('#getINow').show();

                $w('#input1').style.borderColor = '#098961';
                $w('#input1').style.color = '#098961';
                $w('#xIcone').hide();
                $w('#gXIcone').show();
                $w('#preloader').hide();
                if (domainName.split('.').length > 2) { domain = `${domainName.split('.')[1]}.${domainName.split('.')[2]}` } else { domain = domainName.split('.')[1] }
                price = await prices[domain];
                wixWindow.formFactor === 'Desktop' ? $w("#textError").text = `¡Buenas noticias! ${domainName} puede ser tuyo ahora mismo. Desde $${price}/año` :
                    $w("#textError").text = `¡Buenas noticias! ${domainName} puede ser tuyo ahora mismo. 
					 Desde $${price}/año`

                $w("#textError").expand();
                $w('#getINow').onClick(() => {
                    getDomain(`${price}/año `, domainName, 0, 'available')
                })
                endTime = new Date();
                let timeDiff = endTime - startTime; //in ms
                type = "available";
                try {
                    const biEventObject = { evid: 951, responseSpeed: timeDiff, result: domainName, searchTerm: domainName, type: type };
                    await biLogger.log(biEventObject);
                } catch (err) {
                    console.log('search available BI event ERR', err)
                }
            } else {
                let res = await suggest(sanitizedDomain);
                let domain;
                if (res.suggestions.length > 0) {
                    const withIds = res.suggestions.map((item, index) => {
                        if (item.domain.split('.').length > 2) {
                            domain = `${item.domain.split('.')[1]}.${item.domain.split('.')[2]}`
                        } else {
                            domain = item.domain.split('.')[1]
                        }
                        let priceOfDomain = prices[domain]
                        item.price = priceOfDomain
                        item._id = index.toString();
                        return item;
                    });
                    repeaterData = withIds
                    $w('#preloader').hide();
                    $w('#suggestionsrepeater').data = [];
                    $w('#suggestionsrepeater').data = await withIds.slice(0, 6);
                    $w("#repeaterMsg").text = domainName + " está registrado. Elige una de las siguientes opciones.";
                    $w("#repeaterMsg").expand();
                    $w('#xIcone').show();

                    endTime = new Date();
                    let timeDiff = endTime - startTime; //in ms
                    type = "suggestions";
                    try {
                        const biEventObject = { evid: 951, responseSpeed: timeDiff, result: JSON.stringify($w('#suggestionsrepeater').data), searchTerm: domainName, type: type };
                        await biLogger.log(biEventObject);
                    } catch (err) {
                        console.log('suggested domains result BI event ERR', err)
                    }
                } else {
                    $w("#repeaterMsg").text = domainName + " no está disponible. Elige una de las siguientes opciones.";
                    $w("#repeaterMsg").expand();
                    $w('#xIcone').show();
                    $w('#preloader').hide();
                }

            }

        } catch (err) {
            console.error('inner try error: ', err);
            endTime = new Date();
            let timeDiff = endTime - startTime; //in ms

            type = "error";
            try {
                const biEventObject = { evid: 951, responseSpeed: timeDiff, result: err, searchTerm: domainName, type: type };
                await biLogger.log(biEventObject);
            } catch (err2) {
                console.log('inner try BI event ERR', err2)
            }
        }
    } catch (err) {
        $w('#preloader').hide();
        let errorMessage = '';
        switch (err.message) {

        case TLD_NOT_SUPPORTED: {
            $w('#repeaterMsg').text = `Actualmente no registramos ${domainName.slice(domainName.indexOf('.'))} dominios.Selecciona cualquiera de las siguientes opciones.`;
            errorMessage = `Actualmente no registramos ${domainName.slice(domainName.indexOf('.'))} dominios. Selecciona cualquiera de las siguientes opciones.`;
            $w('#repeaterMsg').expand();
            await removeTLD(domainName);
            break;
        }
        case SHORT_DOMAIN: {
            $w('#textError').text = 'Ingresa un dominio que incluya al menos 3 caracteres.'
            errorMessage = 'Ingresa un dominio que incluya al menos 3 caracteres.'
            $w('#textError').expand();
            break;
        }
        case LONG_DOMAIN: {
            $w('#textError').text = 'Escribe un dominio que no incluya más de 63 caracteres.'
            errorMessage = 'Escribe un dominio que no incluya más de 63 caracteres.'
            $w('#textError').expand();
            break;
        }
        case NOT_VALID: {
            $w('#textError').text = 'Introduce sólo letras, números, puntos y guiones.'
            errorMessage = 'Introduce sólo letras, números, puntos y guiones.'
            $w('#textError').expand();
            break;
        }
        }
        endTime = new Date();
        let timeDiff = endTime - startTime; //in ms
    
        type = "error";
        if (errorMessage.length < 1) {
            errorMessage = err.message
        }
        //add here
        try {
            const biEventObject = { evid: 951, responseSpeed: timeDiff, result: errorMessage, searchTerm: domainName, type: type };
            await biLogger.log(biEventObject);
        } catch (err2) {
            console.log('input domain BI event ERR', err2)
        }
    }
}

// async function getDomain(price, domainName, position, type) {
// 	let endTime = new Date();
// 	let seconds = endTime - startTimeView; //in ms
// 	//add here
// 	try {
// 		const biEventObject = { evid: 952, responseSpeed: seconds, domain: domainName, searchTerm: $w('#input1').value, type: type, position: position };
// 		await biLogger.log(biEventObject);
// 	} catch (err2) {
// 		console.log('get domain BI event ERR', err2)
// 	}

// 	const success = await getLoggedInUser();
// 	let loggenInlink = `https://apps.wix.com/redirect-post-domain/?domainName=${domainName}&referralAdditionalInfo=Anonymous-search`;
// 	// let loggenInlink = ``
// 	let anonymousLink = `https://users.wix.com/signin?loginDialogContext=signup&redirectTo=https://apps.wix.com/redirect-post-domain/?domainName=${domainName}%26referralAdditionalInfo=Sign-in&referralUrl=https:%2F%2Fwww.wix.com%2Fdomain%2Fnames%3Fexperiments%3DrightClickDebug&overrideLocale=es`
// 	if (success) { wixLocation.to(loggenInlink); } else { wixLocation.to(anonymousLink); }

// }

async function getDomain(price, domainName, position, type) {
    let endTime = new Date();
    let seconds = endTime - startTimeView; //in ms
    //add here
    try {
        const biEventObject = { evid: 952, responseSpeed: seconds, domain: domainName, searchTerm: $w('#input1').value, type: type, position: position };
        await biLogger.log(biEventObject);
    } catch (err2) {
        console.log('get domain BI event ERR', err2)
    }
    // let voucherTld = await voucherIncluded(domainName)

    // if (voucherTld) {
    //     // wixLocation.to(`https://www.wix.com/wearepages/lior-blank?domain=${domainName}&price=${price}`)
    //     wixLocation.to(`https://www.wix.com/wearepages/es-domain-split?domain=${domainName}&price=${price}`)
    // } else {
    // const success = await getLoggedInUser();
    // let loggenInlink = `https://apps.wix.com/redirect-post-domain/?domainName=${domainName}&referralAdditionalInfo=Anonymous-search`;
    // let anonymousLink = `https://users.wix.com/signin?loginDialogContext=signup&redirectTo=https://apps.wix.com/redirect-post-domain/?domainName=${domainName}%26referralAdditionalInfo=Sign-in&referralUrl=https:%2F%2Fwww.wix.com%2Fdomain%2Fnames%3Fexperiments%3DrightClickDebug`
    // if (success) { wixLocation.to(loggenInlink); } else { wixLocation.to(anonymousLink); }
    // }
    let voucherTld = await voucherIncluded(domainName)

    if (voucherTld) {
        wixLocation.to(`https://www.wix.com/wearepages/es-domain-split?domain=${domainName}&price=${price}`)
    } else {
        const success = await getLoggedInUser();
        let loggenInlink = `https://apps.wix.com/redirect-post-domain/?domainName=${domainName}&referralAdditionalInfo=Anonymous-search`;
        let anonymousLink = `https://users.wix.com/signin?loginDialogContext=signup&redirectTo=https://apps.wix.com/redirect-post-domain/?domainName=${domainName}%26referralAdditionalInfo=Sign-in&referralUrl=https:%2F%2Fwww.wix.com%2Fdomain%2Fnames%3Fexperiments%3DrightClickDebug`
        if (success) { wixLocation.to(loggenInlink); } else { wixLocation.to(anonymousLink); }
    }

    // const success = await getLoggedInUser();
    // let loggenInlink = `https://apps.wix.com/redirect-post-domain/?domainName=${domainName}&referralAdditionalInfo=Anonymous-search`;
    // let anonymousLink = `https://users.wix.com/signin?redirectTo=https://apps.wix.com/redirect-post-domain/?domainName=${domainName}&referralAdditionalInfo=Sign-in&referralUrl=https://es.wix.com/domain/names?experiments=rightClickDebug&loginDialogContext=signup&overrideLocale=es&forceRender=true`
    // if (success) { wixLocation.to(loggenInlink); } else { wixLocation.to(anonymousLink); }
}

function voucherIncluded(domain) {
    let found = false
    let voucherTlds = ['.com', '.net', '.org', '.info', '.biz', '.rocks', '.pictures', '.club', ' .space', '.shop', '.store', '.online', ' .co.uk', '.xyz', '.art', '.de', '.com.br']
    voucherTlds.forEach((tld) => {
        if (domain.endsWith(tld)) {
            found = true
        }
    })
    return found
}

async function removeTLD(domain) {
    let sanitizedDomain = domain.slice(0, domain.indexOf('.'));
    let res = await suggest(sanitizedDomain);
    const withIds = res.suggestions.map((item, index) => {
        if (item.domain.split('.').length > 2) {
            domain = `${item.domain.split('.')[1]}.${item.domain.split('.')[2]}`
        } else {
            domain = item.domain.split('.')[1]
        }
        let priceOfDomain = prices[domain]
        item.price = priceOfDomain
        item._id = index.toString();
        return item;
    });
    $w('#suggestionsrepeater').data = [];
    $w('#suggestionsrepeater').data = withIds;
}

async function lookForTld(domainName) {
    let finalDomain;
    let tlds;

	if(isUserLocalCO){
		tlds = await getTldForPurchaseCO()
	}
	if(isUserLocalMX){
		tlds = await getTldForPurchaseMX()
	}

	if(!isUserLocalCO && !isUserLocalMX){
		tlds = await getTldForPurchase()
	}
	

    if (tlds.includes(domainName)) {
        return false
    }
    const newDomain = await tlds.find(tld => {
        const tldIndex = domainName.indexOf(tld)
        if (tldIndex !== -1 && domainName[tldIndex - 1].match(/^([-a-zA-Z0-9\.]+)$/) === null) {
            finalDomain = domainName.substr(0, tldIndex - 1) + "." + tld
            return tld;
        }
    })
    if (finalDomain) { return finalDomain } else { return domainName }
}

function hideResults() {
    fire = true;
     if (wixWindow.formFactor === 'Desktop') { $w('#disclamer').hide() }
    $w('#xIcone').hide();
    $w('#preloader').hide();
    $w('#gXIcone').hide();
    $w('#textError').collapse();
    $w('#getINow').hide();
    $w('#searchDomain').show();
    $w('#input1').style.borderColor = '#323232';
    $w('#input1').style.color = '#323232';
    $w('#loadMore').collapse();
}